import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import ReactHtmlParser from 'react-html-parser';

import { Label } from '~/modules/coreUI/components/basic/Labels';
import { Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';

const OfferDescription = ({ description }) => (
  <Column fullWidth leftAligned spaceBetween={1.5}>
    <Label size={['md', 'md', 'xl', 'xl']} semiBold primary>
      {i18next.t('ecommerceCoreUI:Product.description')}
    </Label>
    <Label size={['xs', 'xs', 'sm', 'sm']} emphasized>
      {description ? ReactHtmlParser(description) : <Label>{i18next.t('ecommerceCoreUI:Product.NoDescriptionLabel')}</Label>}
    </Label>
  </Column>
);


OfferDescription.propTypes = {
  description: PropTypes.string.isRequired,
};

export default OfferDescription;
